// Dependencies
import React, { useState, useMemo, useEffect } from "react";

// Modules

// App
import { apiEndpoints } from "../../config";

import PostEdit from "../../partials/posts/postEdit";
import { Row, Col } from "react-bootstrap";
import WebformSelector from "../../partials/posts/webformSelector";

export default function FormEdit() {
  //   const extraFields = useMemo(() => ({}), []);
  const [webform, setWebform] = useState("");
  const [post, setPost] = useState(null);

  useEffect(() => {
    if (post) {
      if (post.webform) {
        setWebform(post.webform?.machine_name || post.webform?.id);
      }
    }
  }, [post]);

  const extraFields = useMemo(() => {
    const webformData = webform ? { webform: webform } : null;

    return {
      ...webformData,
    };
  }, [webform]);

  return (
    <PostEdit
      entityType={"webform"}
      apiEndpoint={apiEndpoints.forms}
      screenClassName={"forms"}
      categoryTitle={"Forms category"}
      categoryName={"field_forms_category"}
      targetVid={"webform_categories"}
      returnRoute={"/forms-creator"}
      backBtnText={"Surveys & Forms Library"}
      previewRoute={"/forms/preview"}
      logCustomEventType={"Forms"}
      extraFields={extraFields}
      featuredImageEnabled={true}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
      editorProps={{
        title: true,
        subtitle: true,
        body: true,
        list: true,
        table: true,
        image: true,
        video: true,
        embed: true,
        rule: true,
        buttonGroup: true,
        chart: true,
        map: true,
      }}
      imageBlockEnabled={true}
    >
      {post !== null && (
        <Row>
          <Col xs="auto">
            <WebformSelector
              selectedWebform={webform}
              insertSelections={(selection) => {
                setWebform(selection);
              }}
            />
          </Col>
        </Row>
      )}
    </PostEdit>
  );
}
